// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EditorController from "./editor_controller"
import FlashController from "./flash_controller"
import HelloController from "./hello_controller"
import QrGeneratorController from "./qr_generator_controller"

application.register("editor", EditorController)
application.register("flash", FlashController)
application.register("hello", HelloController)
application.register("qr-generator", QrGeneratorController)
